export default {
  root: {
    flexWrap: 'nowrap',
  },
};
